import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "border-b border-gray-lp-400 py-4" }
const _hoisted_2 = { class: "inline" }
const _hoisted_3 = { class: "font-semibold text-16px pr-2 pl-4 float-left" }
const _hoisted_4 = {
  key: 0,
  class: "text-black-lp-200 pr-3 float-right"
}
const _hoisted_5 = { class: "rounded px-2 py-0 bg-gray-lp-400 text-12px xxl:text-14px" }
const _hoisted_6 = { class: "capitalize" }
const _hoisted_7 = { class: "border-b border-gray-lp-400 py-4" }
const _hoisted_8 = { class: "inline" }
const _hoisted_9 = { class: "text-gray-lp-600 text-12px xxl:text-14px float-left pl-4" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "pt-2" }, "Publish rate + shipping surcharge", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "pt-2" }, "Origin forward rate", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "pt-2" }, "Destination forward rate", -1)
const _hoisted_13 = { class: "pt-2 text-black-lp-300" }
const _hoisted_14 = { class: "text-gray-lp-600 text-12px xxl:text-14px pr-4 float-right" }
const _hoisted_15 = { class: "pt-2 text-right" }
const _hoisted_16 = { class: "pt-2 text-right" }
const _hoisted_17 = { class: "pt-2 text-right" }
const _hoisted_18 = { class: "pt-2 text-right text-black-lp-300" }
const _hoisted_19 = { class: "border-b border-gray-lp-400 py-4" }
const _hoisted_20 = { class: "inline" }
const _hoisted_21 = { class: "text-gray-lp-600 text-12px xxl:text-14px float-left pl-4" }
const _hoisted_22 = { class: "pt-2" }
const _hoisted_23 = { class: "pt-2" }
const _hoisted_24 = { class: "pt-2" }
const _hoisted_25 = { class: "pt-2" }
const _hoisted_26 = { class: "pt-2 text-black-lp-300" }
const _hoisted_27 = { class: "text-gray-lp-600 text-12px xxl:text-14px pr-4 float-right" }
const _hoisted_28 = { class: "pt-2 text-right" }
const _hoisted_29 = { class: "pt-2 text-right" }
const _hoisted_30 = { class: "pt-2 text-right" }
const _hoisted_31 = { class: "pt-2 text-right" }
const _hoisted_32 = { class: "pt-2 text-right text-black-lp-300" }
const _hoisted_33 = { class: "border-b border-gray-lp-400 py-4 flex-col flex" }
const _hoisted_34 = { class: "inline" }
const _hoisted_35 = { class: "text-black-lp-300 text-12px xxl:text-14px float-left pl-4" }
const _hoisted_36 = { class: "pt-2 flex" }
const _hoisted_37 = {
  key: 0,
  class: "text-black-lp-200 ml-1"
}
const _hoisted_38 = { class: "rounded px-2 py-0 bg-gray-lp-400 text-12px xxl:text-14px" }
const _hoisted_39 = { class: "capitalize" }
const _hoisted_40 = { class: "text-black-lp-300 text-12px xxl:text-14px pr-4 float-right" }
const _hoisted_41 = { class: "pt-2 text-right" }
const _hoisted_42 = {
  key: 0,
  class: "inline"
}
const _hoisted_43 = { class: "text-black-lp-300 text-12px xxl:text-14px float-left pl-4" }
const _hoisted_44 = { class: "pt-2 flex" }
const _hoisted_45 = { class: "text-black-lp-300 text-12px xxl:text-14px pr-4 float-right" }
const _hoisted_46 = { class: "pt-2 text-right" }
const _hoisted_47 = {
  key: 0,
  class: "border-b border-gray-lp-400 py-4"
}
const _hoisted_48 = { class: "inline" }
const _hoisted_49 = { class: "text-black-lp-300 text-12px xxl:text-14px float-left pl-4" }
const _hoisted_50 = /*#__PURE__*/_createVNode("div", { class: "pt-2" }, "Harga barang COD", -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("div", { class: "pt-2" }, "Biaya COD", -1)
const _hoisted_52 = {
  key: 0,
  class: "pt-2 text-gray-lp-600"
}
const _hoisted_53 = { class: "text-black-lp-300 text-12px xxl:text-14px pr-4 float-right" }
const _hoisted_54 = { class: "pt-2 text-right" }
const _hoisted_55 = { class: "pt-2 text-right" }
const _hoisted_56 = {
  key: 0,
  class: "pt-2 text-right text-gray-lp-600"
}
const _hoisted_57 = {
  key: 1,
  class: "border-b border-gray-lp-400 py-4"
}
const _hoisted_58 = { class: "flex flex-row justify-between" }
const _hoisted_59 = { class: "flex text-gray-lp-300 text-12px xxl:text-14px float-left pl-4" }
const _hoisted_60 = { class: " w-36" }
const _hoisted_61 = { class: "items-center ml-5 mt-0.5" }
const _hoisted_62 = { class: "text-12px" }
const _hoisted_63 = { class: "text-gray-lp-300 text-12px xxl:text-14px pr-4 float-right" }
const _hoisted_64 = { class: "border-b border-gray-lp-400 py-4 rounded" }
const _hoisted_65 = { class: "inline items-center content-center" }
const _hoisted_66 = { class: "text-12px xxl:text-14px float-left pl-4 items-center" }
const _hoisted_67 = { class: "pr-4 float-right" }
const _hoisted_68 = {
  key: 0,
  class: "text-right text-16px text-red-lp-100"
}
const _hoisted_69 = { class: "border-b border-gray-lp-400 py-4" }
const _hoisted_70 = { class: "inline" }
const _hoisted_71 = { class: "text-12px xxl:text-14px float-left pl-4" }
const _hoisted_72 = { class: "text-yellow-lp-100 " }
const _hoisted_73 = {
  key: 0,
  class: "pt-2",
  style: {"color":"#3D368F"}
}
const _hoisted_74 = { class: "text-12px xxl:text-14px pr-4 float-right" }
const _hoisted_75 = { class: "pt-2 text-right text-yellow-lp-100" }
const _hoisted_76 = {
  key: 0,
  class: "pt-2 text-right",
  style: {"color":"#3D368F"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_ctx.isShow)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: "\n      absolute\n      overflow-y-auto\n      border-l border-r\n      flex flex-col\n      bg-white\n      rounded-bl rounded-br\n      shadow\n    ",
        style: `margin-top: ${_ctx.isDiscountActive ? '100px' : '76px'}; max-height: 85vh; width: 400px;`
      }, [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('bookingShipment.estimation.title')), 1),
            (_ctx.showProductType)
              ? (_openBlock(), _createBlock("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, [
                    _createVNode("span", _hoisted_6, _toDisplayString(_ctx.dataDetail.productType), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _hoisted_10,
              _hoisted_11,
              _hoisted_12,
              _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('bookingShipment.estimation.shipmentRates')), 1)
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, _toDisplayString(_ctx.currency(_ctx.dataDetail.cityRates)), 1),
              _createVNode("div", _hoisted_16, _toDisplayString(_ctx.currency(_ctx.dataDetail.originDistrictRate)), 1),
              _createVNode("div", _hoisted_17, _toDisplayString(_ctx.currency(_ctx.dataDetail.destinationDistrictRate)), 1),
              _createVNode("div", _hoisted_18, _toDisplayString(_ctx.currency(_ctx.dataDetail.shippingCost)), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_19, [
          _createVNode("div", _hoisted_20, [
            _createVNode("div", _hoisted_21, [
              _createVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('bookingShipment.estimation.commoditySurcharge')), 1),
              _createVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('bookingShipment.estimation.weightAdditionalCharge')), 1),
              _createVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('bookingShipment.estimation.additionalDocumentCost')), 1),
              _createVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('bookingShipment.estimation.woodpackingCost')), 1),
              _createVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('bookingShipment.estimation.additionalCost')), 1)
            ]),
            _createVNode("div", _hoisted_27, [
              _createVNode("div", _hoisted_28, _toDisplayString(_ctx.currency(_ctx.dataDetail.commoditySurcharge)), 1),
              _createVNode("div", _hoisted_29, _toDisplayString(_ctx.currency(_ctx.dataDetail.heavyWeightSurcharge)), 1),
              _createVNode("div", _hoisted_30, _toDisplayString(_ctx.currency(_ctx.dataDetail.documentSurcharge)), 1),
              _createVNode("div", _hoisted_31, _toDisplayString(_ctx.currency(_ctx.dataDetail.woodpackingRates)), 1),
              _createVNode("div", _hoisted_32, _toDisplayString(_ctx.currency(_ctx.dataDetail.additionalCost)), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_33, [
          _createVNode("div", _hoisted_34, [
            _createVNode("div", _hoisted_35, [
              _createVNode("div", _hoisted_36, [
                _createVNode("p", null, _toDisplayString(_ctx.$t('bookingShipment.estimation.protection')), 1),
                (_ctx.dataDetail.insuranceName)
                  ? (_openBlock(), _createBlock("span", _hoisted_37, [
                      _createVNode("span", _hoisted_38, [
                        _createVNode("span", _hoisted_39, _toDisplayString(_ctx.dataDetail.insuranceName?.replace("Insurance", "")), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_40, [
              _createVNode("div", _hoisted_41, _toDisplayString(_ctx.currency(_ctx.dataDetail.insuranceRates - _ctx.dataDetail.insuranceAdminFee)), 1)
            ])
          ]),
          (!_ctx.accountIsForeign)
            ? (_openBlock(), _createBlock("div", _hoisted_42, [
                _createVNode("div", _hoisted_43, [
                  _createVNode("div", _hoisted_44, [
                    _createVNode("p", null, _toDisplayString(_ctx.$t("bookingShipment.estimation.protectionCost")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_45, [
                  _createVNode("div", _hoisted_46, _toDisplayString(_ctx.currency(_ctx.dataDetail.insuranceAdminFee)), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.isForeignCurrency && (_ctx.isCOD || _ctx.isDFOD))
          ? (_openBlock(), _createBlock("div", _hoisted_47, [
              _createVNode("div", _hoisted_48, [
                _createVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _hoisted_51,
                  (_ctx.isEnableCodBooking)
                    ? (_openBlock(), _createBlock("div", _hoisted_52, " PAD Fee "))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_53, [
                  _createVNode("div", _hoisted_54, _toDisplayString(_ctx.isDFOD ? _ctx.currency(0) : _ctx.currency(_ctx.goodsValue)), 1),
                  _createVNode("div", _hoisted_55, _toDisplayString(_ctx.currency(_ctx.dataDetail.codFee)), 1),
                  (_ctx.isEnableCodBooking)
                    ? (_openBlock(), _createBlock("div", _hoisted_56, _toDisplayString(_ctx.currency(_ctx.dataDetail.padFee)), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isDiscountActive && _ctx.dataDetail.discountBoards)
          ? (_openBlock(), _createBlock("div", _hoisted_57, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataDetail.discountBoards, (promo, index) => {
                return (_openBlock(), _createBlock("div", {
                  class: "inline",
                  key: index
                }, [
                  _createVNode("div", _hoisted_58, [
                    _createVNode("div", _hoisted_59, [
                      _createVNode("div", _hoisted_60, _toDisplayString(_ctx.startCase(promo.pdcCategory)) + " Promo", 1),
                      _createVNode("div", _hoisted_61, [
                        _createVNode("div", {
                          class: "\n                  flex flex-row\n                  bg-green-lp-700\n                  text-white text-10px\n                  px-1\n                  rounded-md\n                  cursor-pointer\n                ",
                          onMouseenter: ($event: any) => (_ctx.onOpenTooltipPromo($event, index)),
                          onMouseleave: ($event: any) => (_ctx.onOpenTooltipPromo($event, index))
                        }, [
                          _createVNode("p", null, _toDisplayString(promo.pdcPromoDiscount) + "% Off", 1),
                          _createVNode(_component_Icons, {
                            name: "info",
                            class: "w-3 ml-1"
                          })
                        ], 40, ["onMouseenter", "onMouseleave"]),
                        _createVNode(_component_OverlayPanel, {
                          ref: `infoPromo${index}`,
                          appendTo: "body",
                          class: "text-center",
                          style: {"width":"200px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode("p", _hoisted_62, _toDisplayString(promo.pdcName) + " sampai dengan " + _toDisplayString(_ctx.formatDateWithoutTime(promo.pdcEndDate)), 1)
                          ]),
                          _: 2
                        }, 1536)
                      ])
                    ]),
                    _createVNode("div", _hoisted_63, _toDisplayString(_ctx.currency(promo.pdcDiscountAmount)), 1)
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_64, [
          _createVNode("div", _hoisted_65, [
            _createVNode("div", _hoisted_66, [
              _createVNode("div", {
                class: 
              `${
                _ctx.isDiscountActive && !_ctx.isCODOnly ? 'pt-5' : 'pt-2'
              } font-semibold text-black-lp-300 items-center`
            
              }, _toDisplayString(_ctx.isCOD || _ctx.isDFOD
                ? _ctx.$t("bookingV3.shipment.checkTariff.detail.chargesPayable")
                : _ctx.$t("bookingShipment.estimation.totalCost")), 3)
            ]),
            _createVNode("div", _hoisted_67, [
              _createVNode("div", {
                class: 
              `pt-2 text-right text-16px ${
                _ctx.isDiscountActive && !_ctx.isCODOnly
                  ? 'text-gray-lp-600 line-through'
                  : 'text-red-lp-100 font-semibold'
              }`
            
              }, _toDisplayString(_ctx.isCODOnly || (!_ctx.isDiscountActive && _ctx.isDFOD)
                ? _ctx.currency(_ctx.dataDetail.codAmount)
                : _ctx.currency(_ctx.dataDetail.totalTariff)), 3),
              (_ctx.isDiscountActive && !_ctx.isCODOnly)
                ? (_openBlock(), _createBlock("div", _hoisted_68, _toDisplayString(_ctx.isDFOD
                ? _ctx.currency(_ctx.dataDetail.codAmount)
                : _ctx.currency(_ctx.dataDetail.totalTariffAfterDiscount)), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_69, [
          _createVNode("div", _hoisted_70, [
            _createVNode("div", _hoisted_71, [
              _createVNode("div", _hoisted_72, _toDisplayString(_ctx.$t('bookingV3.shipment.checkTariff.detail.estimationTax')), 1),
              (_ctx.isCodRetail)
                ? (_openBlock(), _createBlock("div", _hoisted_73, _toDisplayString(_ctx.$t('bookingV3.shipment.checkTariff.detail.returnCost')), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_74, [
              _createVNode("div", _hoisted_75, _toDisplayString(_ctx.currency(_ctx.dataDetail.taxRates)), 1),
              (_ctx.isCodRetail)
                ? (_openBlock(), _createBlock("div", _hoisted_76, _toDisplayString(_ctx.currency(_ctx.codReturnFee)), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ], 4))
    : _createCommentVNode("", true)
}